import { Grid } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, isSelected }) => css`
    height: auto;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    font-family: 'Poppins';
    transition: all 0.2s ease;
    border: 2px solid transparent;

    &:hover {
      box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
    }

    ${isSelected && css`
      border: 2px solid ${theme.palette.primary.main};
      box-shadow: 0px 4px 16px ${theme.palette.primary.main}30;
      background: ${theme.palette.primary.main}05;
    `}
  `}
`;

export const Amenities = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;

  span {
    display: inline-flex;
    align-items: center;
    background: #f5f5f5;
    border-radius: 16px;
    padding: 4px 10px;
    font-size: 11px;
    color: #555;
    white-space: nowrap;

    svg {
      font-size: 14px;
      margin-right: 4px;
      color: #4caf50;
    }
  }
`;

export const RoomName = styled.span`
  ${({ theme }) => css`
    font-weight: 600;
    font-size: 18px;
    width: 100%;
    margin-bottom: 8px;
    color: ${theme.palette.primary.main};
    display: block;
  `}
`;

export const RoomImageContainer = styled.div`
  width: 100%;
  max-width: 220px;
  height: 160px;
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 960px) {
    max-width: 100%;
    height: 200px;
  }
`;

export const RoomImage = styled.img`
  width: 180px;
  height: 150px;
  object-fit: cover !important;
  border-radius: 6px;
`;

export const GridFlexible = styled(Grid)``;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;

  span {
    width: 100%;
    font-size: 13px;
    color: #666;
    line-height: 1.5;
    max-height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`;

export const Description = styled.span`
  ${({ theme }) => css`
    font-weight: 600;
    font-size: 13px;
    width: 100%;
    margin-bottom: 6px;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  `}
`;

export const PriceDetails = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-wrap: wrap;

    span {
      display: flex;
      justify-content: flex-end;
    }

    button {
      width: 60%;
      span {
        justify-content: center;
      }
    }
  `}
`;

export const TotalValue = styled.div`
  ${({ theme }) => css`
    font-weight: 700;
    font-size: 25px;
    width: 100%;
    letter-spacing: 1px;
    color: #000;
    opacity: 75%;
  `}
`;

export const NightsQty = styled.span`
  ${({ theme }) => css`
    font-weight: 800;
    font-size: 15px;
    width: 100%;
    /* margin: 10px 0px; */
    color: #000;
    opacity: 75%;
  `}
`;

export const DailyValue = styled.span`
  ${({ theme }) => css`
    font-weight: 300;
    font-size: 15px;
    width: 100%;
    color: #000;
    opacity: 60%;
    margin-top: 10px;
  `}
`;

export const Policies = styled.div`
  ${({ theme }) => css`
    font-size: 10px;
    width: 100%;
    letter-spacing: 1px;
    color: #000;
    opacity: 75%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: flex-end;

    p {
      text-align: right;
      padding-left: 20px;
    }
  `}
`;

export const PoliciesTitle = styled.span`
  ${({ theme }) => css`
    font-size: 12px;
    color: red;
    margin-top: 7px;
    margin-bottom: 5px;
  `}
`;

export const PoliciesTexts = styled.span`
  ${({ theme }) => css`
    font-size: 10px;
    font-weight: 200;
  `}
`;

export const PoliciesTitle2 = styled.span`
  ${({ theme }) => css`
    font-size: 10px;
    font-weight: 600;
    color: #000;
    opacity: 75%;
    margin-right: 3px;
  `}
`;

export const CancellationPolicy = styled.div`
  ${({ type }) => css`
    display: inline-flex;
    align-items: center;
    margin-top: 12px;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;

    ${type === "nonRefundable" && css`
      background: #fef2f2;
      color: #dc2626;
      border: 1px solid #fecaca;
    `}

    ${type === "freeCancellation" && css`
      background: #f0fdf4;
      color: #16a34a;
      border: 1px solid #bbf7d0;
    `}
  `}
`;

export const RoomRatesContainer = styled.div`
  margin-top: 20px;
`;
